import { render, staticRenderFns } from "./Pallets.vue?vue&type=template&id=4c64a101&scoped=true"
import script from "./Pallets.vue?vue&type=script&lang=ts"
export * from "./Pallets.vue?vue&type=script&lang=ts"
import style0 from "./Pallets.vue?vue&type=style&index=0&id=4c64a101&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c64a101",
  null
  
)

export default component.exports